export const globalErrorKey = '__GLOBAL__';
